// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const cn = {
  game: `游戏`,
  games: `游戏`,
  sport: `运动`,
  center: `中心`,
  mines: `地雷`,
  crash: `撞车`,
  lucky_colour: `幸运颜色`,
  dice: `骰子`,
  limbo: `地狱边境`,
  lucky_gift: `幸运礼物`,
  all_games: `所有游戏`,
  game_history: `游戏历史`,
  coupon_code: `优惠码`,
  telegram: `电报`,
  customer_service: `客户服务`,
  player: `玩家`,
  winner: `赢家`,
  all_bets: `所有赌注`,
  my_bets: `我的赌注`,
  name: `名字`,
  time: `时间`,
  bet_amount: `赌注金额`,
  prediction: `预测`,
  payout: `支付`,
  login: `登录`,
  register: `注册`,
  username_placeholder: `用户名`,
  please_input_your_x: `请输入您的{{x}}`,
  captcha: `验证码`,
  forgot_password: `忘记密码`,
  minor_note: `要访问此网站，请确保您已满18岁并同意`,
  terms_of_service: `服务条款`,
  by_signing_in: '通过登录或注册，您同意我们的',
  dont_have_account: `还没有账户吗?`,
  sign_up: `还没有账户吗`,
  username: `用户名`,
  email: `电子邮件`,
  full_name: `全名`,
  confirm_18: `我确认我已满18岁，并且我已阅读`,
  already_have_account: `已有账户?`,
  share: `分享`,
  deposit: `存款`,
  bonus: `奖金`,
  app: `应用程序`,
  load_more: `加载更多`,
  details: `加载更多`,
  helps: `帮助`,
  kyc_policy: `KYC政策`,
  privacy_policy: `隐私政策`,
  responsible_gaming: `负责任的游戏`,
  terms_and_condition: `条款和条件`,
  faq: `常见问题`,
  about_us: `关于我们`,
  amount: `金额`,
  extra: `额外`,
  deposit_bonus: `存款奖金`,
  do_not_participate: `不参与促销活动`,
  payment_problem: `支付问题`,
  click_for_help: `点击获取帮助`,
  deposit_notes: `存款说明`,
  available_balance: `可用余额`,
  withdraw: `取款`,
  withdrawal_notes: `取款说明`,
  withdrawal_note1: `当前的取款次数`,
  withdrawal_note1_1: `贵宾`,
  withdrawal_note2: `取款手续费:`,
  min: `Min:`,
  max: `Max:`,
  opening_times: `营业时间:`,
  withdrawal_note3: `1.最快的取款时间为10分钟内`,
  withdrawal_note4: `2.确保您的取款信息准确无误，如果取款信息错误，可能会导致您的资金丢失.`,
  withdrawal_note5: `3.请随时与我们联系，如果您有任何问题.`,
  notifications: `通知`,
  invalid_x: `无效的 {{x}}`,
  captcha_not_match: `验证码不匹配`,
  invalid_x_must_be_atleast_y_characters: `无效的 {{x}}，必须至少有 {{y}} 个字符`,
  x_is_required: `{{x}} 为必填项`,
  phone_number: '电话号码',
  phone_num_x_max: `电话号码最多为 {{x}} 位数字`,
  email_sent: `邮件已发送，请查收您的邮箱.`,
  enter_valid_email: `请输入有效的电子邮件.`,
  confirm: `确认`,
  password_atleast_6_characters: `密码必须至少包含 6 个字符.`,
  password_reset_success: `密码重置成功!.`,
  new_password: `新密码`,
  bank: '银行',
  bank_transfer: `银行转账`,
  bank_name: `银行名称`,
  account_name: `账户名称`,
  account_number: `账户号码`,
  pix_number: `PIX 号码`,
  drop_or_select: `删除或选择文件`,
  drop_files_here: `将文件拖到此处`,
  transfer_to: `转账到`,
  upload_receipt: `上传收据`,
  select_bonus: `选择奖金`,
  no_promotion: `没有促销`,
  please_upload_receipt: `请上传收据`,
  bank_account: `银行账户`,
  bank_branch: `银行分行`,
  pay_id: `支付 ID`,
  add_account: `添加账户`,
  account_holder_name: `账户持有人姓名`,
  name_of_the_account_holder: `账户持有人的姓名`,
  fill_in_bank_account: `填写银行账户`,
  fill_in_pay_id: `填写支付 ID`,
  fill_in_bank_branch: `填写银行分行`,
  withdraw_information: `提款信息`,
  note: `备注`,
  amount_withdrawn: `提款金额`,
  amount_no_exceed_balance: `提款金额不得超过可用余额`,
  minimum_withdraw_amount_is_x: `最低提款金额为 {{x}}`,
  transaction_history: `交易历史`,
  date_from: `开始日期`,
  date_to: `结束日期`,
  account_name_must_be_4: `账户名称长度必须大于 4`,
  account_number_must_be_x: `账户号码长度必须为 10 到 14 位`,
  minimum_length_is_x: `最小长度为 {{x}}`,
  maximum_length_is_x: `最大长度为 {{x}}`,
  payment_method: `支付方式`,
  mode: `模式`,
  no_bank_account: `您没有任何可提现的账户，请立即添加`,
  please_select_bank: `请选择银行账户`,

  bet_history: `投注历史`,
  game_provider: `游戏供应商`,
  bet_count: `投注次数`,
  win_loss: `胜/负`,
  rebate: `返利`,
  turnover: `周转`,
  game_category: `游戏类别`,

  you_have_x_unread_messages: `您有 {{x}} 条未读消息`,
  deposit_amount_between_x_and_y: `存款金额必须在 {{x}} 和 {{y}} 之间`,
  minimum_amount_is_x_y: `最小金额为 {{x}}{{y}}`,

  // all
  all: `所有`,
  title: `标题`,
  date: `日期`,
  type: `类型`,
  status: `状态`,
  remark: `备注`,
  category: `类别`,
  please_select_x: `请选择 {{x}}`,
  save: `保存`,

  change_password: `更改密码`,
  current_password: `当前密码`,
  confirm_password: `确认新密码`,
  submit: `提交`,
  password_changed: `密码已更改`,
  x_must_be_y_characters: `{{x}}至少必须有{{y}}个字符`,
  reset_password: `重置密码`,
  casino: `赌场`,
  slots: `老虎机`,
  live_casino: `真人赌场`,
  fishing: `钓鱼`,
  sports: `运动的`,
  cards: `牌`,
  clear: `清除`,
  search: `搜索`,
  new: `新的`,
  logout: `退出`,
  choose_date: `选择日期`,
  select_both_date: `选择“起始日期”和“结束日期`,
  from: `从`,
  to: `到`,
  apply: `申请`,
  promotions: `促销活动`,
  learn_more: `了解更多`,
  password_doesnt_match: `密码不匹配`,
  cancel: `取消`,
  confirm_to_pay: `确认付款`,
  deposit_amount: `存款金额`,
  loading_please_wait: `正在加载，请稍候`,
  account: `帐户`,
  profile: `轮廓`,
  bank_list: `银行名单`,
  in_maintenance: `维护中`,
  birthday: `生日`,
  birthday_bonus: `输入您的生日即可获得奖励! 🎉🎁`,
  referral_code: `推荐码`,
  friend_referral_code: '朋友推荐码',
  no_friend: '( 如果没有朋友则留空 )',
  referral: `推荐`,
  my_referral: `我的推荐`,
  my_claim: `我的索赔`,
  claim_profit: `索取利润`,
  available_profit: `可用利润`,
  claimed_profit: `声称利润`,
  all_time_profit: `所有时间利润`,
  referral_note_on_x: `每当您的朋友在 {{x}} 上玩游戏时，您都可以赚取利润`,
  tier: `等级`,
  commission: `委员会`,
  referred_member: `推荐会员`,
  profit_earned: `赚取利润`,
  account_information: `账户信息`,
  invite_friends: `邀请好友`,
  how_it_work: `它是如何运作的?`,
  invite_note: `当您的朋友使用您的推荐代码注册时，您将获得独家推荐奖金!`,
  share_via: `分享通过`,
  referral_link: `推荐链接`,
  total_profit: `利润总额`,
  copied: `已复制`,
  nothing_to_claim: `没有什么可索赔的`,
  claim_history: `索赔历史`,
  downline: `我的下线`,
  last_x_digit_bank_ref_number: `已成功与{{x}}链接！请首次注册您的帐户`,
  bank_ref_number_validation_x: `银行参考号为必填项，长度必须为 {{x}} 个字符`,
  sort: '种类',
  login_directly: `直接登录`,
  our_game_provides: `我们的游戏提供商`,
  refer_and_reward: `推荐与奖励`,
  linked_successfully_x: `已成功关联 {{x}}！请首次注册您的账户`,
  more_x_of_y: `更多的 {{x}}/{{y}}`,
  default: `默认`,
  promotion: `晋升`,
  daily_mission: '每日任务',
  agent: '代理人',
  contact_us: '联系我们',
  download: '下载',
  cash_claim: '现金索赔',
  demo: '演示',
  favorites: '收藏夹',
  popular: '受欢迎的',
  claim_bonus: `领取奖金`,
  insufficient_balance: `余额不足`,
  currently_displaying: '当前显示 {{z}} 个游戏中的 {{x}} 个 {{y}} 个游戏',
  all_x: '所有{{x}}',
  no_results: '未找到结果',
  search_games: '搜索游戏',
  please_scan_using_your: `请使用您的扫描`,
  vip_level: `VIP等级`,
  bonus_direct: `直接奖金`,
  rebate_level: `返利等级l`,
  vip_header: `在JStar99上所有在老虎机、桌面和纸牌游戏、捕鱼、视频、体育和彩票游戏上的投注将永久累计。有效投注 = 永久收入和财富!`,
  vip_example: `
  Example 1: 会员累计存款达到100万，晋升为VIP等级2，获得R$210奖金，并享受3.50%的返利；当累计存款达到600万时，晋升为VIP等级3，获得R$800奖金，并享受4%的返利`,
  activity_rules: `活动规则:`,
  activity_rules_1: `1. 所有奖金必须达到 3 倍流水才能申请提款`,
  activity_rules_2: `2. 请在截止日期前领取返利奖金，逾期将被视为放弃;`,
  activity_rules_3: `3. 会员参与活动由系统自动统计，如有异议，以JStar99调查结果为准;`,
  activity_rules_4: `4. 如果您忘记会员账号/密码，请联系“24小时在线客服”协助您恢复账号信息;`,
  activity_rules_5: `5. JStar99保留随时更改、停止或取消此促销活动的权利.`,
  activity_rules_6: `6. 不保存免费游戏，购买免费游戏`,
  activity_rules_7: `7. 不能与任何奖金合并`,
  activity_rules_8: `8. 每笔存款的最大提款限额为R$100,000.00`,
  event_instructions: '活动说明',
  agent_p1: '在应用程序和社交媒体上分享您的独特链接',
  recommended_games: '推荐游戏',
  all_provider: '所有提供商',
  agent_p2:
    'Facebook、Instagram、Tiktok、Telegram、WhatsApp、YouTube等，赶快邀请大家，通过您的独特链接注册的会员将成为您的直接代理。但是请注意，您邀请的新会员必须是真实有效的.',
  agent_step1:
    '成功邀请朋友完成首次存款，您可以获得R$5奖金。例如，如果您邀请10个人完成首次存款，您可以赚取R$50。邀请的人越多，您获得的奖金就越多。您可以在促销页面查看您的历史记录并注册，享受更多奖金和高额佣金.',
  agent_step2:
    '如果您的客人投注R$1或更多，您就可以享受高额佣金！您可以赚取最高5%的终身佣金，并享有终身邀请！系统将在次日早上7点结算前一天的佣金.',
  agent_step2_1: '如何获得：登录 - 邀请推广 - 收取佣金',
  agent_table1: '老虎机、捕鱼和区块链的投注佣金率如下:',
  agent_table1_1: '客户充值20，投注200',
  person: '人',
  agent_table2_title1: '会员投注',
  agent_table2_title2: '仅限老虎机游戏',
  agent_table2_example:
    '例如：您有100名会员，每日实际投注总额估计为100万雷亚尔。您当天获得的佣金为：1,000,000 x 1.20% = 12,000雷亚尔。月收入10万雷亚尔非常容易实现.',
  reminder: '提醒',
  agent_reminder:
    '相同IP、相同设备、相同姓名、银行卡及其他信息的会员账户只能参与一次，任何违反规则的行为将无法享受此奖金，或者该账户将被没收，且账户将被永久冻结',
  agent_step3_1: '会员参与活动由系统自动计数，如有异议，以JStar99进行的分析结果为准',
  agent_step3_2: '如果您忘记了会员账户/密码，请联系我们的24小时客服团队帮助您找回账户信息',
  agent_step3_3: 'JStar99保留随时更改、暂停或取消促销活动的权利',
  agent_step3_4: '代理商能够以现金或钱包中的积分形式接收佣金奖金',
  agent_step3_5: '不保存免费游戏，购买免费游戏',
  agent_step3_6: '不能与任何奖金和存款合并',
  agent_step3_7: '仅适用于老虎机游戏',
  promo_concluded: '促销活动已结束！请明天再来查看!',
  can_only_claim: '只能在{{x}}到{{y}}巴西时间之间领取奖金',
  please_login: '请先登录以领取奖金!',
  back_to_home: '返回首页',
  bonus_claimed: '奖金已领取!',

  network_error: '网络错误',
  we_have_sent_otp: '我们已将验证码发送到您的电话号码',
  your_otp_expire: '您的验证码将在以下时间过期',
  didnt_receive: '没有收到信息吗?',
  send_again: '重新发送',
  resend_again: '再次发送在',
  invalid_verification: '无效的验证码!',
  otp_expired: '验证码已过期，请重新输入您的电话号码并重试!',
  otp_expired_redirect: '验证码已过期！正在重定向到登录页面',
  captcha_check_failed: '验证码检查失败!',
  verify_phonenumber: '验证电话号码',
  send_otp: '发送验证码',
  success_verification: '您的电话号码已验证!',
  press_get_code: '按“获取验证码”按钮通过短信接收验证码',
  otp_sent: '验证码已发送！请输入以下验证码以继续',
  get_code: '获取代码',
  verify: '核实',
  verification_code: '验证码',
  otp_not_found: '未找到 OTP 函数!',
  yes: `是的`,
  no: `不`,
  please_register_to_claim_bonus: `请注册领取奖金!`,
  home: `家`,
  history: `历史`,
  live_transactions: `实时交易`,
  live: `居住`,
  x_categories: '{{x}} 类别',
  x_category: '{{x}} 类别',
  live_chat: `实时聊天`,
  invite_friend: '邀请好友',
  copy_referral_link: '复制推荐链接',
  balance: '平衡',
  level: '等级',
  refresh: '刷新',
  password: '密码',
  password_placeholder: '6 - 20 个字符',
  optional: '(选修的)',
  login_here: '在此登录',
  enter_text_on_the_left: '在左侧输入文字',
  more_info: '更多信息',
  back: '后退',
  number_exists: '此电话号码已被注册!',
  number_not_exists: '此电话号码未注册!',
  please_download_x_to_play: '请下载 {{x}} 来玩',
  play_now: '立即播放',
  logout_confirmation: '退出确认',
  are_you_sure_to_logout: '您确定要退出吗?',
  desposit_from_bank: '银行存款',
  dont_show_again: '不再显示',
  must_start_with: `必须以 (010, 011, 012, 013, 014, 015, 016, 017, 018, 019) 开头`,
  password_must_be_6_to_20: `密码长度必须为 6 - 20`,
  no_balance: '无余额',
  maximum_withdraw_amount_is_x: `最高提款金额为 {{x}}`,
  change_language: '更改语言',
  for_all_categories: '对于所有类别',
  register_with_telegram: '注册电报',
  registration_method: '报名方式',
  join_x: '加入 {{x}}',
  reg_instruction_1: '点击下面的按钮将“加入 JStar99”发送到我们的电报账户',
  reg_instruction_2: '按下电报中的“分享我的联系人”发送您的电话号码以继续注册',
  reg_instruction_3: '请等待1分钟',
  reg_instruction_4: '使用您的 Telegram 电话号码登录，密码为 000000',
  reg_instruction_5: '登录后修改密码',
  reg_instruction_6: '注册时请使用真实姓名和账号',
  input_otp: '请输入一次性密码',
  send_again_in_x: '{{x}} 后再次发送',
  otp_sent_enter_code_password: '验证码已发送。请在下方输入验证码和您的新密码',
  win: '赢',
  bet: '赌注',
  payout_ratio: '派息率',
  rank: '秩',
  leaderboard: '排行榜',
  popular_games: '热门游戏',
  nothing_to_show: '没有什么可显示的',
  minimum_deposit: '最低存款额',
  minimum_withdraw: '最低提款额',
  maximum_deposit: '最高存款额',
  maximum_withdraw: '最大提款额',
  clear_balance: '清晰的余额',
  this_will_set_balance: '这会将您的余额设置为零，继续?',
  min_max_withdraw_will_reset: '提现或余额清空后，最低/最高提现额度将重置',
  providers: '供应商',
  next: `下一个`,
  close: `关闭`,
  no_data: `无数据`,
  add: `添加`,
  remarks: `评论`,
  join_us_for_latest: `加入我们获取最新资讯`,
  join_content: `信息/新奖励/免费积分`,
  subscribe: `订阅`,
  play: `玩`,
  recent_games: '最近的比赛',
  you_won_x: '你赢得了 {{x}}',
  coins: '金币',
  spin: '旋转',
  congratulations: '恭喜',
  continue: '继续',
  insufficient_points: '积分不足',
  nice_try: '不错的尝试',
  points: '积分',
  download_ios: '下载(IOS)',
  settings: '设置',
  id_number_telco: 'PIN码',
  deposit_from_bank: '支付渠道',
  id_number: '账户号码',
  // TODO:翻译成其他语言
};

export default cn;
